import { Site, SiteApiResponse } from '@/apis/sites/types/sitesApi';

export const siteFromApiAdapter = (site: SiteApiResponse): Site => {
  return {
    siteId: site.SiteID,
    aeic: site.AEIC,
    siteName: site.SiteName,
    customerName: site.CustomerName,
    type: site.Type,
    address: site.Address,
    address2: site.Address2,
    city: site.City,
    state: site.State,
    zipCode: site.ZipCode,
    county: site.County,
    phone: site.Phone,
    fax: site.Fax,
    status: site.Status,
    country: site.Country,
    comments: site.Comments,
    notes: site.Notes,
    lastModified: site.LastModified,
    modifiedBy: site.ModifiedBy,
    addressExt: site.AddressExt,
    gFactsSiteId: site.GFactsSiteID,
  };
};
